const ProcessSearchSchema = () => ({
  title: 'AgSUS Process Search',
  block: 'agsusProcessSearch',
  fieldsets: [
    {
      id: 'default',
      title: 'Padrão',
      fields: ['title', 'intro', 'fonteSede', 'fonteDsei', 'itemsPerPage'],
    },
  ],
  properties: {
    title: {
      title: 'Título',
      type: 'string',
      default: 'Filtrar processos',
    },
    intro: {
      title: 'Texto de apoio',
      type: 'string',
      default: 'Utilize os campos abaixo para consultar determinado processo.',
    },
    fonteSede: {
      title: 'Fonte — processos da Sede',
      description:
        'Pasta varrida até dois níveis (News Items e Links soltos nela e nas ' +
        'subpastas, como a de vagas na Sede). ' +
        'Vazio usa /trabalhe-na-agsus/processos-seletivos.',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: false,
    },
    fonteDsei: {
      title: 'Fonte — seleções dos DSEIs',
      description:
        'Pasta varrida até dois níveis (editais dentro das páginas de cada ' +
        'DSEI). Vazio usa /trabalhe-na-agsus/saude-indigena.',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: false,
    },
    itemsPerPage: {
      title: 'Itens por página',
      type: 'number',
      default: 20,
    },
  },
  required: [],
});

export default ProcessSearchSchema;
